
<template>
  <p class="text-left px-16">
    令和6年度の受験料は収入印紙での納付となります。<br />
    出願後、下記「令和６年度日本語教員試験収入印紙提出用台紙」をクリックをすると「収入印紙提出用台紙」が表示されますので印刷し、以下住所宛てに収入印紙を郵送してください。<br />
    所定の受験料より多い収入印紙を頂いても返還いたしません。不足があった場合、期日までに不足分を納付いただけない場合には、受験資格がなくなります。すでに送付いただいた収入印紙は返還いたしません。<br />
    ※収入印紙と収入証紙は違いますのでお気をつけください。<br />
    <v-btn text x-large color="primary" @click.stop="openRevenueStampSheet"
      style="text-decoration: underline; font-weight: bold"
    >令和６年度日本語教員試験収入印紙提出用台紙</v-btn>
    <br /><br />
    〒151-0053<br />
    東京都渋谷区代々木３丁目25番3号あいおいニッセイ同和損保新宿ビル12階<br />
    レカムBPO株式会社内日本語教員試験事務局<br />
    TEL： 050-5433-7942（2024年9月6日消印有効）
  </p>
</template>

<script >
export default {
  methods:{
    openRevenueStampSheet(){
      window.open("/api/stamp_sheet", "_blank")
    }
  }
}

</script>

<style scoped>

</style>
